<template>
  <div style="display: flex;align-items: center;">
    <!-- <a-avatar :size="34" :src="userData.headImgUrl" /> -->
    <a-dropdown>
      <!-- <div class="ant-dropdown-link" @click="e => e.preventDefault()">
        <span class="name">{{ userData.nickName }}</span>
        <a-icon type="down" />
      </div> -->
      <a-avatar
        :size="34"
        :src="userData.headImgUrl || defaultAvatar"
      />

      <a-menu slot="overlay">
        <a-menu-item
          v-for="(menu, index) in menus"
          :key="index"
        >
          <a
            @click.prevent.stop="clicks(menu)"
            style="color:#181D21; font-size: 14px"
            href="javascript:;"
          >{{ menu.title }}</a>
        </a-menu-item>
      </a-menu>
    </a-dropdown>
    <interest-modal
      :value.sync="visible"
      @save="save"
    ></interest-modal>
  </div>
</template>
<script>
import InterestModal from './InterestModal.vue'
import { mapMutations } from 'vuex'
import Vue from 'vue'
const defaultAvatar = require('@/assets/defaultAvatar.png')
export default {
  name: '',
  props: {
    userData: {
      type: Object,
      default: null,
      required: true
    }
  },
  data () {
    return {
      visible: false,
      defaultAvatar,
      menus: [
        {
          title: '我的课程',
          name: 'course'
        },
        // TODO 我的消息暂时隐藏
        // {
        //   title: '我的消息',
        //   name: 'qa'
        // },
        {
          title: '我的兴趣'
        },
        {
          title: '账号管理',
          name: 'account'
        },
        {
          title: '退出登录'
        }
      ],
      overlayStyle: {
        color: 'red',
        fontSize: '30px'
      }
    }
  },
  components: {
    InterestModal
  },
  methods: {
    ...mapMutations('course', ['setPlanclassesId']),
    save (ev) {
      // console.log(this.visible, ev)
      this.$message.success('保存成功！')
    },
    clicks ({ name, title }) {
      if (name) {
        this.$router.push({
          name: name,
          query: { ocode: Vue.ls.get('code') },
        })
        return
      }
      if (title === '我的兴趣') {
        this.visible = true
      }
      if (title === '退出登录') {
        this.$store.dispatch('logout')
        this.setPlanclassesId('')
        this.$router.replace({ name: 'login' })
      }
    }
  }
}
</script>
<style lang="less" scoped>
.ant-dropdown-link {
  display: flex;
  align-items: center;
  height: 45px;
  line-height: 45px;
  color: #AEB5C5;
  cursor: pointer;
  .name {
    display: inline-block;
    margin-left: 8px;
    margin-right: 18px;
  }
}
</style>
